module.exports = __webpack_public_path__ + "img/xieshou-banner-home.873cd2af.png";